import styled from 'styled-components'

export const MainContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};

  @media (max-width: 1120px) {
    gap: 80px;
  }
`

export const Container = styled.div`
  display: grid;
  grid-template-columns: 0.3fr 0.7fr;
  gap: ${props => props.theme.spacing.sp24};
  margin-top: ${props => props.theme.spacing.sp16};

  @media (max-width: 1120px) {
    grid-template-columns: 1fr;
    gap: 50px;
  }
`

export const ChartContainer = styled.div`
  height: 230px;
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: ${props => props.theme.spacing.sp16};
`

export const ModalTitle = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
  align-items: center;
`
